export const PUBLIC_PAGES = [
  "/login",
  "/cadastro",
  // "/314119201815",
  "/redefinir-senha",
  "/barte/3ds",
  "/bo",
  "/hml-bo",
  "/payfac",
  "/bo",
  "/hml-payfac",
  "/auth/impersonate",
];

export function isPublicPage(pathname: string): boolean {
  return PUBLIC_PAGES.some((page) => pathname.startsWith(page));
}
